const focusRed = [173, 9, 29];
const lightFocusRed = [...focusRed, 0.3];
export const tourColor = "#C01421";
export const selfDrawnHikingColor = "#4169e1";
export const stopOverColor = "#FBC200";
export const darkGrey = "#130f03";

export const TRACK_Z_INDEX = 200;

export const sketchControlPoint = [
  {
    "z-index": TRACK_Z_INDEX,
    "circle-radius": 16,
    "circle-fill-color": lightFocusRed,
  },
  {
    "z-index": TRACK_Z_INDEX,
    "circle-radius": 8,
    "circle-fill-color": focusRed,
  },
];
